import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Layout } from "antd";
import { useAuthenticatedFetch } from "@/Api/Axios";
import { formFields, initialValues } from "@/Assets/Mocks/ResendVerification.js";
import CommonForm from "@/Components/Common/CommonForm";
import { ToastContext } from "@/Context/ToastContext";

const { Content } = Layout;

export const VerifyToken = () => {
  const verificationToken = new URLSearchParams(window.location.search).get("token");
  const email = new URLSearchParams(window.location.search).get("email");
  const fetch = useAuthenticatedFetch();
  const { showToast } = useContext(ToastContext);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    const checkVerification = async () => {
      const res = await fetch.get(`/verify/${verificationToken}/${email}`);
      setFormValues(email ? { email: email } : initialValues);
      setLoading(false);
      if (res.data?.verified) {
        setVerificationSuccess(true);
      } else {
        setVerificationSuccess(false);
      }
    };
    checkVerification();
  }, []);

  const handleResendVerification = async () => {
    const res = await fetch.post("/resend", { email: email });
    if (res.data) {
      showToast("Verification mail send sucessfully");
    } else {
      showToast("Try Again!");
    }
  };

  if (verificationSuccess) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ maxWidth: "600px", width: "100%" }}>
            <Alert
              type="success"
              message="Verification Successful"
              description={
                <Link to="/login" style={{ textDecoration: "none" }}>
                  Login
                </Link>
              }
              showIcon
            />
          </div>
        </Content>
      </Layout>
    );
  }

  if (!verificationSuccess && !loading) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ maxWidth: "600px", width: "100%" }}>
            <Alert
              type="error"
              message="Verification Failed"
              description={
                <CommonForm
                  onSubmit={handleResendVerification}
                  initialValues={formValues}
                  formFields={formFields}
                  isSave={true}
                  label="Send Verification Email Again"
                  buttonVariant="primary"
                  noValueChanged={false}
                />
              }
              showIcon
            />
          </div>
        </Content>
      </Layout>
    );
  }
};
